export function Card({
  variant,
  title,
  subtitle,
  imageSrc,
  imageAlt = "",
  inactive = false,
  className = "",
  onClick,
  children,
  ...rest
}) {
  const isClickable = typeof onClick === "function" && !inactive;
  const onKeyDown = (e) => {
    if (!isClickable) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <article
      className={`card card--${variant} ${inactive ? "card--inactive" : ""} ${isClickable ? "card--clickable" : ""} ${className}`.trim()}
      aria-disabled={inactive}
      role={isClickable ? "button" : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onClick={isClickable ? onClick : undefined}
      onKeyDown={onKeyDown}
      {...rest}
    >
      {inactive ? <span className="card__badge">Скоро</span> : null}
      <h3 className="card__title">{title}</h3>
      {subtitle != null && subtitle !== "" ? (
        <p className="card__subtitle">{subtitle}</p>
      ) : null}
      {imageSrc ? <img className="card__image" src={imageSrc} alt={imageAlt} loading="lazy" decoding="async" /> : null}
      {children}
    </article>
  );
}
